import React from "react";
import styles from "../specialities.module.css";
import SpecialitiesBanner from "../../../components/Banners/Speacialities-Banner/speacialities-banner";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";
import SpecialityFeatures from "../../../components/SpecialityFeatures/specialityFeatures";
import TextOnly from "../../../components/TextOnly/textOnly";
import MetaTags from "../../../components/MetaTags";

const FleetManagement = () => {
  const bannerContent = {
    heading: "Fleet Management",
    subText: (
      <>
        Managing a delivery fleet is no easy task, but with Ninjas Code’s Fleet Management Solutions, you can streamline your operations and deliver unparalleled service to your customers. We help you optimize and track your fleet with tools like real-time fleet tracking software, delivery route optimization software, and more, making it simple to manage every aspect of your fleet with ease.
      </>
    ),
  };

  const specialityAbout = [
    {
      aboutImage: {
        url: "assets//Speciality-Images/Real-Time-Fleet-Tracking.webp",
        alt: "Real-Time Fleet Tracking",
      },
      aboutTitle: { title: `Real-Time Fleet Tracking`, highlightedTitle: "" },
      aboutDescription: (
        <>
         Monitor your fleet's location in real-time with integrations like GPS fleet tracking using APIs such as Google Maps or Apple Maps.
        </>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Delivery-Route-Optimization.webp",
        alt: "Delivery Route Optimization",
      },
      aboutTitle: { title: `Delivery Route Optimization`, highlightedTitle: "" },
      aboutDescription: (
        <>
Save time and fuel with route planning software that minimizes delays and reduces operational costs, ensuring seamless delivery fleet optimization.        </>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Driver-Performance-Metrics.webp",
        alt: "Driver Performance Metrics",
      },
      aboutTitle: { title: `Driver Performance Metrics`, highlightedTitle: "" },
      aboutDescription: (
        <>
Measure key metrics like delivery times, customer feedback, and driver efficiency using driver performance management tools to enhance team productivity.        </>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Fleet-Communication-Tools.webp",
        alt: "Fleet Communication Tools",
      },
      aboutTitle: { title: `Fleet Communication Tools`, highlightedTitle: "" },
      aboutDescription: (
        <>
Facilitate direct communication between drivers, admins, and customers with integrated fleet communication tools, resolving issues quickly and ensuring smooth delivery operations.        </>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Custom-Alerts-Notifications.webp",
        alt: "Custom Alerts & Notifications",
      },
      aboutTitle: { title: `Custom Alerts & Notifications`, highlightedTitle: "" },
      aboutDescription: (
        <>
Stay informed with instant alerts about delivery progress, potential delays, or vehicle maintenance scheduling to keep your fleet running smoothly.        </>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Scalable-Fleet-Management.webp",
        alt: "Scalable Fleet Management",
      },
      aboutTitle: { title: `Scalable Fleet Management`, highlightedTitle: "" },
      aboutDescription: (
        <>
Our scalable fleet management solution grows with your business, supporting an expanding fleet without compromising performance.
</>
      ),
      flexReverse: "true",
    },
  ];

  const featurePoints = [
    <>GPS vehicle tracking system for accurate real-time monitoring.</>,
    <>Intelligent delivery route optimization software for efficient scheduling.</>,
    <>Driver assignment, shift management, and performance tracking.</>,
    <>Fleet maintenance management tools for timely servicing and repairs.</>,
    <>Comprehensive fleet analytics for cost and efficiency insights.</>
  ];

  const finalThoughts = [
    {heading: `Take Control of Your Fleet Today`},
    {subText: `With Ninjas Code’s Fleet Management Solutions, you’ll transform your delivery operations into a well-oiled machine. Contact us now to discuss how our delivery management and vehicle tracking tools can revolutionize your business!`},
  ]

  return (
    <div>
       <MetaTags
     title="Efficient & Scalable Fleet Management for Delivery Business"
     description="Streamline your delivery operations with Ninjas Code Fleet Management Solutions. Get advanced features like real-time tracking, route optimization, and more."
     />
      <SpecialitiesBanner content={bannerContent} />

      <div className={styles.specialitiesAbout}>
        <div className={styles.container}>
          <h2>Why Choose Our Fleet Management Solution?</h2>
          <ImageWithText aboutContent={specialityAbout} />
        </div>
      </div>

      <SpecialityFeatures features={featurePoints} />

      <TextOnly 
      content={finalThoughts}
      width
      />
    </div>
  );
};

export default FleetManagement;
